module.exports = __webpack_public_path__ + "static/media/close-button.193ee6d1.svg";